import React from "react";
import { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { editUserApi, updateUserActiveStatus, resendInviteApi } from "../services/api";
import '../assets/styles/EditUserModal.scss';

const EditUserModal: React.FC<propTypes> = (props: propTypes) => {
    const [user, setUser] = useState({...props.user});
 
     useEffect(() => {
         setUser(props.user);
     }, [props.user]);

    const updateUser = (e) => {
        e.preventDefault();
        const params = {
            userId: user.userId,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            roleName: user.role,
        };
        editUserApi(params).then(() => {
            props.refreshUsers();
            props.onHide();
            toast.success("User updated successfully");
        }).catch((err) => {
            props.refreshUsers();
            toast.error(err.toString());
        });
    };

    const updateUserActiveStatusUser = () => {
        updateUserActiveStatus({ email: user.email, isActive: !user.isActive }).then(() => {
            props.refreshUsers();
            props.onHide();
            toast.success(`User is ${user.isActive ? "disabled" : "enabled"}`);
        }).catch((err) => {
            toast.error(err.toString());
        });
    };

    const resentInvite = () => {
        const params = { firstName: user.firstName, lastName: user.lastName, email: user.email };
        resendInviteApi(params).then((response) => {
            props.refreshUsers();
            props.onHide();
            toast.success(response);
        })
            .catch((err) => {
                toast.error(err.toString());
            });
    };

    return (
        <Fragment>
            <Modal
                id="EditUserModal"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={props.show}
                onHide={props.onHide}
            >
                <Modal.Header id="closebtn" closeButton>
                    <Modal.Title id="title">Edit User</Modal.Title>
                </Modal.Header>
                <form onSubmit={updateUser} data-testid="editform">
                    <Modal.Body>
                        <div className="row mb-3 mt-3">
                            <div className="col-1" />
                            <label className="col-3 col-form-label">
                                First Name
                                <em className="text-danger">*</em>
                            </label>
                            <div className="col-7">
                                <input
                                    data-testid="firstName" type="text" onChange={(e) => { setUser({ ...user, firstName: e.target.value }); }} value={user.firstName}
                                    onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your first name")}
                                    onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} className="form-control" id="recipient-fname" required
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-1" />
                            <label className="col-3 col-form-label">
                                Last Name
                                <em className="text-danger">*</em>
                            </label>
                            <div className="col-7">
                                <input
                                    data-testid="lastName" className="form-control" onChange={(e) => { setUser({ ...user, lastName: e.target.value }); }} value={user.lastName}
                                    onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your last name")}
                                    onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} id="message-lname" required
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-1" />
                            <label className="col-3 col-form-label">
                                Email
                                <em className="text-danger">*</em>
                            </label>
                            <div className="col-7">
                                <input
                                    data-testid="email" type="email" onChange={(e) => { setUser({ ...user, email: e.target.value }); }}
                                    onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your e-mail address")}
                                    onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} className="form-control" value={user.email} id="email" required
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-1" />
                            <label className="col-3 col-form-label">
                                Role
                                <em className="text-danger">*</em>
                            </label>
                            <div className="col-7 my-auto">
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" data-testid="admin-role" type="radio" onChange={(e) => { setUser({ ...user, role: e.target.value }); }} id="inlineRadio1" name="role" value="Admin" checked={user.role === "Admin"} />
                                    <label className="form-check-label">Admin</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" data-testid="viewer-role" type="radio" onChange={(e) => { setUser({ ...user, role: e.target.value }); }} id="inlineRadio2" value="Viewer" name="role" checked={user.role === "Viewer"} />
                                    <label className="form-check-label">Viewer</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" onChange={(e) => { setUser({ ...user, role: e.target.value }); }} id="inlineRadio2" value="Maintainer" checked={user.role === "Maintainer"} />
                                    <label className="form-check-label">Maintainer</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-1" />
                            <div className="col-11">
                                <button type="button" className="btn btn-link ps-0" id="btn-user-delete" data-testid="deleteUserBtn" disabled={!user.emailConfirmed} onClick={props.showConfirmModal}>Delete</button>
                                <button type="button" data-testid="activateBtn" onClick={updateUserActiveStatusUser} className="btn btn-link" id="btn-user-disable" disabled={!user.emailConfirmed}>
                                    {user.isActive ? "Disable" : "Enable"}
                                </button>
                                <button
                                    type="button" disabled={user.emailConfirmed}
                                    onClick={resentInvite} data-testid="resendInvite-button" className="btn btn-link" id="btn-user-resentInvite"
                                >
                                    Resend Invitation
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer id="footer">
                        <button type="button" className="btn btn-secondary" id="btn btn-cancelEdit" onClick={props.onHide}>Cancel</button>
                        <button type="submit" className="btn btn-primary" id="btn btn-updateEdit">Update</button>
                    </Modal.Footer>
                </form>
            </Modal>
        </Fragment>
    );
}

type propTypes = {
    user: { userId: string, emailConfirmed: boolean, firstName: string, lastName: string, email: string, role: string, isActive: boolean },
    refreshUsers: () => void,
    onHide: () => void,
    showConfirmModal: () => void,
    show: boolean
};


export default EditUserModal;
